import React from 'react';
import { Loadable } from 'shared/hocs/loadable';
import { Loader } from 'shared/ui/loader';


export const ArchetypeLoadable = Loadable({
    loader: (): any => import('./Archetype').then((res) => res.Archetype),
    loading: <Loader/>,
});
